import React from 'react';
import { connect } from 'react-redux';

import { updateGlove } from '../../actions/creators';
import syncPreview from '../higher-order/SyncPreview';
import CustomPythonButtons from '../CustomPythonButtons';

const Inbetween = ({
  customPythons,
  inbetweenCurrentCustomPython,
  onInsideCustomPythonClick,
  outsideCurrentCustomPython,
  onOutsideCustomPythonClick,
}) => (
  <div className="step-item-view-wrap pull-right">
    <CustomPythonButtons
      title="BRIDGE COLOR"
      className="finger-inbetween-color-wrap"
      images={customPythons}
      currentCustomImage={inbetweenCurrentCustomPython}
      onClick={onInsideCustomPythonClick}
    />
    <CustomPythonButtons
      title="PINKY OUTSIDE COLOR"
      className="finger-outside-color-wrap"
      images={customPythons}
      currentCustomImage={outsideCurrentCustomPython}
      onClick={onOutsideCustomPythonClick}
    />
  </div>
);

const mapStateToProps = (state) => {
  const { inBetweenPython, pinkyOutsidePython } = state.glove;

  return {
    customPythons: state.builder.leatherColors[state.glove.leatherGrade.id],
    inbetweenCurrentCustomPython: inBetweenPython,
    outsideCurrentCustomPython: pinkyOutsidePython,
  };
};

const mapDispatchToProps = dispatch => ({
  onInsideCustomPythonClick: color => dispatch(updateGlove({ inBetweenPython: color })),
  onOutsideCustomPythonClick: color => dispatch(updateGlove({ pinkyOutsidePython: color })),
});

export default syncPreview(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Inbetween), 'fingerSide');
